

export function updateObjectById(array, newObject, id) {
    // Вспомогательная рекурсивная функция для обхода дерева
    function traverse(items) {
        return items.map(item => {
            if (item.id === id) {
                // Нашли нужный объект — заменяем его
                return { ...newObject, children: item.children }; // сохраняем детей, если есть
            }
            if (item.children && item.children.length > 0) {
                // Рекурсивно обходим детей
                return {
                    ...item,
                    children: traverse(item.children)
                };
            }
            return { ...item }; // возвращаем копию без изменений
        });
    }

    return traverse(array);
}

export function insertBeforeById(array, newObject, id) {
    function traverse(items) {
        const result = [];
        for (let i = 0; i < items.length; i++) {
            const item = items[i];

            if (item.id === id) {
                result.push(newObject); // сначала вставляем новый
                result.push({ ...item, children: item.children ? traverse(item.children) : [] });
            } else {
                if (item.children && item.children.length > 0) {
                    result.push({
                        ...item,
                        children: traverse(item.children)
                    });
                } else {
                    result.push({ ...item });
                }
            }
        }
        return result;
    }

    return traverse(array);
}

export function insertAfterById(array, newObject, id) {
    function traverse(items) {
        const result = [];
        for (let i = 0; i < items.length; i++) {
            const item = items[i];

            if (item.id === id) {
                result.push({ ...item, children: item.children ? traverse(item.children) : [] });
                result.push(newObject); // вставляем после
            } else {
                if (item.children && item.children.length > 0) {
                    result.push({
                        ...item,
                        children: traverse(item.children)
                    });
                } else {
                    result.push({ ...item });
                }
            }
        }
        return result;
    }

    return traverse(array);
}

export function insertChildById(array, newChild, parentId) {
    function traverse(items) {
        return items.map(item => {
            const clonedItem = { ...item };

            if (clonedItem.id === parentId) {
                // Нашли родителя — добавляем ребёнка в children
                const children = Array.isArray(clonedItem.children) ? [...clonedItem.children] : [];
                children.push(newChild);
                return {
                    ...clonedItem,
                    children: children
                };
            }

            // Если у элемента есть дети — рекурсивно обходим
            if (clonedItem.children && clonedItem.children.length > 0) {
                return {
                    ...clonedItem,
                    children: traverse(clonedItem.children)
                };
            }

            return clonedItem;
        });
    }

    return traverse(array);
}

export function appendAtTopLevel(array, newObject, id) {
    return [...array, newObject];
}

export function removeById (array, id) {
    function traverse(items) {
        const result = [];
        for (const item of items) {
            if (item.id === id) {
                continue; // пропускаем удаляемый элемент (не добавляем в результат)
            }

            if (item.children && item.children.length > 0) {
                // Рекурсивно обрабатываем детей
                const filteredChildren = traverse(item.children);
                result.push({
                    ...item,
                    children: filteredChildren
                });
            } else {
                result.push({ ...item });
            }
        }
        return result;
    }

    return traverse(array);
}